import React, { ComponentPropsWithRef, useEffect, useRef, useState } from 'react'
import { Button, TextField } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from '../../i18n/useTranslation'
import { useCommonCtx } from '../../context/useCommonCtx'

type Props = ComponentPropsWithRef<'div'> & {
    onClose: () => void
    initialComment?: string
    onConfirm: (comment: string) => void
    open: boolean
}
const MAX_CHAR = 400;
export const CommentModal = (p: Props) => {
    const {
        className,
        onClose,
        onConfirm,
        initialComment = '',
        open,
        color,
        style,
        key, // will unmound and remount the component automatically
        ...rest
    } = p
    const t = useTranslation(useCommonCtx())

    // const ref = useRef<HTMLInputElement>(null);
    // useEffect(() => {
    //     ref.current?.focus()
    // }, [key])

    const [comment, setComment] = useState(initialComment)
    const remainingChars = MAX_CHAR - comment.length

    return (
        <Dialog
            ref={ref => { if (ref) ref.focus(); }}
            fullWidth
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle
                sx={{ m: 0, p: 2, paddingRight: 6 }}
                id="customized-dialog-title"
            >
                {t('comment_title')}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => onClose()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers className="p-8">
                <TextField
                    inputProps={{
                        autoFocus: true,
                        zIndex: 1000,
                        ref: (e: HTMLInputElement | null) => { if (e) e.focus(); }
                    }}
                    ref={ref => { if (ref) ref.focus(); }}
                    autoFocus
                    label={`${remainingChars} ${t('comment_remaining')}`}
                    multiline
                    rows={10}
                    fullWidth
                    size="medium"
                    placeholder={t('comment_placeholder')}
                    value={comment}
                    onChange={(e) => {
                        const newValue = e.target.value.substring(
                            0,
                            MAX_CHAR - 1
                        )
                        setComment(newValue)
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        onClose()
                    }}
                >
                    {t('btn_back')}
                </Button>
                <Button
                    variant="contained"
                    className="w-3/4"
                    autoFocus
                    onClick={() => {
                        onConfirm(comment)
                    }}
                >
                    {t('comment_save')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
